export enum FrequencyEnum {
  YEAR = 'year',
  HALF_YEAR = 'half_year',
  QUARTER = 'quarter',
  MONTH = 'month',
}
